// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__j2vJZ","signatureBlock":"Footer_signatureBlock__18jFL","signature":"Footer_signature__3iUY4"};